/* eslint-disable */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData } from "utils/Gateway";
import { assetImages } from "constants";

const AssignExpertPopup = ({
  selectedFaqId = null,
  setSelectedFaqId = () => {},
  afterPopupClose = () => {},
}) => {
  const token = localStorage.getItem("token");

  const { t, i18n } = useTranslation();

  const [expertLoading, setExpertLoading] = useState(false);
  const [expertList, setExpertList] = useState([]);
  const [faqExperts, setFaqExperts] = useState([]);

  const [expertName, setExpertName] = useState("");

  const [checkedExperts, setCheckedExperts] = useState({}); // To store checked state

  const [isSaving, setisSaving] = useState(false);

  const [validation, setValidation] = useState({
    expertError: false,
  });

  //validation function
  const validationHandler = () => {
    let isValid = true;

    if (faqExperts.length === 0) {
      setValidation((prevState) => ({ ...prevState, titleError: true }));
      isValid = false;
    }

    return isValid;
  };

  //function for get expert list
  const getAllExpertList = async (isLoading = false, expertString = "") => {
    try {
      let requestURL =
        url.API_BASE_URL + url.API_GET_APP_USERS + `?token=${token}&limit=50`;

      if (isLoading) {
        setExpertLoading(true);
      }

      if (expertString !== "") {
        requestURL += `&userstring=${expertString}`;
      }

      const response = await getData(requestURL);

      setExpertLoading(false);

      console.log(response);

      if (response.status) {
        setExpertList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for check expert
  const expertCheckHandler = (expertId, isChecked) => {
    setCheckedExperts((prevState) => ({
      ...prevState,
      [expertId]: isChecked, // Update checked state for the specific expert
    }));

    if (isChecked) {
      // Add to faqExperts if checked, if not already there
      if (!faqExperts.includes(expertId)) {
        setFaqExperts((prevState) => [...prevState, expertId]);
      }
    } else {
      // Remove from faqExperts if unchecked
      setFaqExperts((prevState) => prevState.filter((id) => id !== expertId));
    }
  };

  //get faq details
  const getFaqDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_FAQ_DETAILS +
        `/${selectedFaqId}?token=${token}`;

      const response = await getData(requestURL);

      if (response.status) {
        const data = response.data;

        if (data.experts && data.experts.length > 0) {
          for (let expertId of data.experts) {
            expertCheckHandler(expertId, true);
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //save faq function
  const saveFaqHandler = async (e) => {
    if (validationHandler()) {
      try {
        setisSaving(true);

        let apiData = {
          experts: faqExperts,
        };

        let requestURL = url.API_BASE_URL;

        let response = {};

        if (selectedFaqId) {
          requestURL += url.API_UPDATE_FAQ + `/${selectedFaqId}?token=${token}`;

          response = await putData(requestURL, apiData);
        }

        setisSaving(false);

        // console.log(response);

        if (response.status) {
          // close the popup
          let offCanvasPopup = document.querySelector("#offcanvasAssignExpert");
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();

          resetHandler();
          afterPopupClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const resetHandler = () => {
    setExpertList([]);
    setFaqExperts([]);
    setExpertName("");
    setCheckedExperts({});
    setSelectedFaqId(null);

    setValidation({
      expertError: false,
    });
  };

  useEffect(() => {
    if (selectedFaqId) {
      getAllExpertList(true);
      getFaqDetails();
    }
  }, [selectedFaqId]);

  useEffect(() => {
    if (expertName !== "" && expertName.length > 0) {
      const filterSearch = expertList.filter((expert) =>
        expert.username.toLowerCase().includes(expertName.toLowerCase())
      );

      if (filterSearch.length === 0) {
        getAllExpertList(false, expertName);
      }
    } else {
      const timeoutId = setTimeout(() => {
        getAllExpertList(false);
      }, 500); // Debounce the input for better UX
      return () => clearTimeout(timeoutId);
    }
  }, [expertName]);

  // Filtered list based on search input if length > 2
  const filteredExperts =
    expertName.length > 2
      ? expertList.filter((expert) =>
          expert.username.toLowerCase().includes(expertName.toLowerCase())
        )
      : expertList;

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasAssignExpert"
      aria-labelledby="offcanvasAssignExpertLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              person_add
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasAssignExpertLabel"
            >
              {t("Assign Experts")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage experts for this FAQ")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="search position-relative">
                  <button className="d-block position-absolute top-50 border-0 text-primary material-symbols-outlined bg-transparent ms-3 translate-middle-y">
                    search
                  </button>
                  <input
                    type="text"
                    className="form-control fs-sm shadow-none border border-gray-300 ps-5"
                    placeholder="Search expert by name"
                    id="expertSearch"
                    value={expertName}
                    onChange={(e) => setExpertName(e.target.value)}
                  />
                  {validation.expertError && (
                    <div className="text-danger mt-2">
                      Please select at least one expert.
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="question"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Experts")}
                </label>
                <ul
                  className="experts list-unstyled mb-0"
                  id="appexperts"
                  style={{ maxHeight: "250px", overflowY: "auto" }}
                >
                  {expertLoading
                    ? [1, 2, 3, 4].map((_, index) => (
                        <li
                          key={index}
                          className="px-3 py-3 d-flex align-items-center gap-3 border-bottom border-gray-200"
                        >
                          <div className="placeholder-glow w-100">
                            <span
                              className="placeholder col-2 me-2 rounded-circle"
                              style={{ width: "2.2rem", height: "2.2rem" }}
                            ></span>
                            <span className="placeholder col-6"></span>
                          </div>
                        </li>
                      ))
                    : filteredExperts.map((expert) => (
                        <li
                          key={expert._id}
                          className="expert-item px-3 py-3 d-flex align-items-center gap-3 border-bottom border-gray-200 bg-white rounded-3 transition"
                        >
                          {/* Checkbox */}
                          <input
                            type="checkbox"
                            className="form-check-input flex-shrink-0 border-2 shadow-none m-0 me-2"
                            id={`expert_checkbox_${expert._id}`}
                            checked={!!checkedExperts[expert._id]}
                            value={expert._id}
                            onChange={(e) =>
                              expertCheckHandler(expert._id, e.target.checked)
                            }
                          />

                          {/* Avatar */}
                          <div
                            className="flex-shrink-0 rounded-circle overflow-hidden border border-gray-300"
                            style={{ width: "2.2rem", height: "2.2rem" }}
                          >
                            <img
                              alt={expert.username}
                              src={
                                expert.userimage === ""
                                  ? assetImages.defaultUser
                                  : url.SERVER_URL + expert.userimage
                              }
                              className="img-fluid w-100 h-100 object-cover object-center"
                            />
                          </div>

                          {/* User Info */}
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-semibold text-dark">
                              {expert.username}
                            </p>
                          </div>

                          {/* Details Link */}
                          <a
                            href={`${url.FRONTEND_BASE_URL}/peoples/details/${expert._id}`}
                            className="text-primary d-flex align-items-center gap-1 ms-auto fw-semibold"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span>Details</span>
                            <span className="material-symbols-outlined fs-6">
                              chevron_right
                            </span>
                          </a>
                        </li>
                      ))}
                </ul>
              </div>
            </div>

            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveFaqHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Faq")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AssignExpertPopup;
